/**
 * Decorates a function that returns a promise, rejecting the promise if
 * the function takes more than `timeout` milliseconds to resolve
 * @param func the function returning a promise
 * @param timeout the number of milliseconds to wait before rejecting
 */
function withTimeout<Args extends Array<any>, T>(
  func: (...args: Args) => Promise<T>,
  timeout = 12000,
): (...args: Args) => Promise<T> {
  let timer: ReturnType<typeof setTimeout>;
  return (...args: Args) =>
    new Promise((resolve, reject) => {
      func(...args)
        .then(resolve)
        .catch(reject)
        .finally(() => {
          clearTimeout(timer);
        });
      timer = setTimeout(() => {
        reject(new Error(`${func.name}: ${timeout / 1000} secs timeout reached`));
      }, timeout);
    });
}

export default withTimeout;
